import { setSpecificMessage, multipleOf } from "valibot";
setSpecificMessage(
  multipleOf,
  (issue) => `Multiple invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);